import { ChangeDetectionStrategy, Component, HostBinding, Inject, Signal } from '@angular/core';

import { BetslipConfig, EpcotConfig } from '@frontend/sports/common/client-config-data-access';
import { Store, createSelector } from '@ngrx/store';

import { DropdownOption } from '../../../../../lib/dropdown/models';
import { ILinearBetslipMessages } from '../../../../base/models/betslip-messages';
import {
    ILinearBetslipMessagesProviderService,
    LINEAR_BETSLIP_MESSAGES_PROVIDER_INJECTION_TOKEN,
} from '../../../../base/services/betslip-messages-provider.service';
import { IBetslipInfoMessage } from '../../../common/models';
import { InfoMessagesActions } from '../../../info-messages/actions';
import BetslipSystemBetActions from '../../actions';
import { ISlipInfo, SystemModes } from '../../models';
import { systemBetBankerEnabledSelector, systemBetPickOddStateSelector } from '../../selectors';

export const selectOpenPicksCount = createSelector(
    systemBetPickOddStateSelector,
    (picks) => Object.values(picks).filter((p) => p.isSelected && !p.isLocked).length,
);

@Component({
    selector: 'bs-system-bet-bar-linear',
    templateUrl: './system-bet-bar-linear.component.html',
    styleUrls: ['./system-bet-bar-linear.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export default class SystemBetBarLinearComponent {
    @HostBinding('class.bs-digital-system-bet-bar-linear-container') hostCssClass = true;

    readonly bankerHelpMessageId = 'bankerHelpInfoMessage';
    protected bankerHelpUrl: string;
    protected systemModes: SystemModes;
    protected messages: ILinearBetslipMessages;
    protected systemOptions: DropdownOption<ISlipInfo>[];
    protected selectedOption: DropdownOption<ISlipInfo>;
    protected readonly isBankerActive: Signal<boolean>;
    protected readonly pickCount: Signal<number>;
    protected betslipInfoMessage: IBetslipInfoMessage;
    protected isBankerEnabled = false;
    protected isEpcot = false;

    constructor(
        private store: Store,
        @Inject(LINEAR_BETSLIP_MESSAGES_PROVIDER_INJECTION_TOKEN) messageProvider: ILinearBetslipMessagesProviderService,
        private betslipConfig: BetslipConfig,
        epcotConfig: EpcotConfig,
    ) {
        this.isEpcot = epcotConfig.isEnabled;

        this.messages = messageProvider.getMessages();

        this.betslipInfoMessage = {
            header: this.messages.betslip.common.BankerHelpHeader,
            infoText: this.messages.betslip.common.BankerHelpText,
            closeText: this.messages.betslip.common.BankerHelpClose,
        };

        this.systemModes = this.messages.betslip.systemModes;

        this.isBankerEnabled = this.betslipConfig.isBankerEnabled;

        this.isBankerActive = this.store.selectSignal(systemBetBankerEnabledSelector);
        this.pickCount = this.store.selectSignal(selectOpenPicksCount);
    }

    toggleBanker(): void {
        this.store.dispatch(BetslipSystemBetActions.toggleSystemBanker());
    }

    toggleBankerHelp(): void {
        this.store.dispatch(InfoMessagesActions.toggle({ messageId: this.bankerHelpMessageId }));
    }
}
